import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import { useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import { CustomBtn } from '../../../../components/button/button';

function NayabMultipleCards(props) {
console.log(props)
    const image = useSelector((state) => state.Api.imageServer);
    const WebSrn = localStorage.getItem('WebSrn');

    const [cards, setCards] = useState([]);
    const [catchUrl, setCatchUrl] = useState('');

    // ✅ CSS selection state
    const [selectedCSS, setSelectedCSS] = useState(
        'https://print.xaosoft.com/NayabCardHTML.css'
    );

    // ✅ CSS mapping (clean + scalable)
    // const CSS_FILES = {
    //     nayab: 'https://print.xaosoft.com/CardHTML.css',
    //     nayabHtml: 'https://print.xaosoft.com/NayabCardHTML.css',
    //     cardNayab: 'https://print.xaosoft.com/WasilyDefault.css',
    //     xaosoft: 'https://print.xaosoft.com/XaoSoft.css',
    // };
    const server = 'https://print.xaosoft.com/' // for online use
    // const server = 'http://localhost:3000/' //for offline use 
    const CSS_FILES = {
        nayab: server+'horizintalCard.css',
        nayabHtml: server+'NayabCardHTML.css',
        wasilyCard: server+'WasilyDefault.css',
        xaosoft: server+'XaoSoft.css',
    };
    function separateLanguages(text) {
        const arabicRange = /[\u0600-\u06FF]/;
        const englishChars = [];
        const arabicChars = [];

        for (let char of text) {
            if (arabicRange.test(char)) {
                arabicChars.push(char);
            } else {
                if (char !== ' ') {
                    englishChars.push(char);
                } else {
                    arabicChars.push(char);
                }
            }
        }

        return arabicChars.join('');
    }

    useEffect(() => {
        setCards(props.info || []);

        let currentUrl = window.location.href;
        const containsStudents = currentUrl.includes('Students');
        const classStudents = currentUrl.includes('Subjects');

        if (containsStudents) {
            currentUrl = currentUrl.replace("/Private/View/Students", "");
        } else if (classStudents) {
            currentUrl = currentUrl.replace("/Private/Subjects", "");
        } else {
            currentUrl = currentUrl.replace("/Private/View/Teacher", "");
        }

        setCatchUrl(currentUrl);
    }, [props.info]);

    const NewWindowContent = () => {
        return (
            <div className='multipleCards Neda'>
                {cards.map((card, ind) => (
                    <>
                    <div key={ind} className="specificDivClass">
                        <div className="card">
                            {/* <div className="card-header">
                                Temporary Card
                            </div> */}

                            <div className={
                                card?.studentOrTeacher === 'student'
                                    ? 'teacherLine student'
                                    : 'teacherLine teacher'
                            }></div>

                            <div
                                className='qrCode'
                                style={
                                    card?.studentOrTeacher !== 'student'
                                        ? { padding: '3px 62px' }
                                        : null
                                }
                            >
                               
                            </div>

                            <div
                                className="card-body"
                                style={
                                    card?.studentOrTeacher !== 'student'
                                        ? { padding: '7px 6px' }
                                        : null
                                }
                                >
                                {/* {card?.studentOrTeacher === 'student' && (
                                    <div className='rollNumber'>{card?.RollNum}</div>
                                )} */}

                                <div className={
                                    card?.studentOrTeacher === 'student'
                                        ? 'student-info'
                                        : 'teacher-info'
                                }>
                                    {/* <h2>{card?.Name} </h2>  */}
                                    <h2> 
                                        <div>اسم</div> 
                                        <div>:</div> 
                                        <div>{card?.Name_P}</div>
                                    </h2> 

                                    {card?.studentOrTeacher === 'student' ? (
                                        <>
                                            {/* <p>ولد {card?.FName_P}</p> */}
                                    <h2> 
                                        <div>ولد</div>
                                        <div>:</div>
                                        <div>{card?.FName_P}</div></h2> 
                                            {/* <p>ولد {card?.FName_P}</p> */}
                                    <h2> 
                                        <div>صنف</div>
                                        <div>:</div>
                                        <spna>{separateLanguages(card?.Class)}</spna>
                                    </h2>
                                        </>
                                    ) : (
                                        <h2 style={{ fontSize: '22px', height: '20px' }}>
                                            {card?.Job}
                                        </h2>
                                    )}
                                    <h2> 
                                        <div>اساس </div>
                                        <div>:</div>
                                        <div className='asasnumber'>{card?.RollNum}</div>
                                    </h2> 

                                </div>
                            </div>
                            <div className='second'>
                                <QRCode
                                    value={`wasilytech,${card?.RollNum},${card?.card},${card?.Name}`}
                                    size={card?.studentOrTeacher === 'student' ? 50 : 50}
                                />
                            </div>
                            <div className='image'>       
                                <img className="student-photo" src={`${image}/${card?.Picture}`}  alt="Student Photo" />
                            </div>
                            {/* <div className={
                                card?.studentOrTeacher === 'student'
                                    ? 'card-footer student'
                                    : 'card-footer teacher'
                            }>
                                Wasily Technology
                            </div> */}
                        </div>
                    </div>
                    
                        {ind == 9 || ind == 19 || ind == 29 || ind == 39  || ind == 49  || ind == 59  || ind == 69  || ind == 79  || ind == 89 || ind == 99 || ind == 109 || ind == 119 || ind == 129? 
                        <div class="pageBreak"></div>
                         : null}
                    </>
                ))}
            </div>
        );
    };

    const openNewWindow = () => {

        const windSize =
            props.getSize === 'full'
                ? 'width=816,height=1056'
                : 'width=224,height=365';

        const newWindow = window.open('', '_blank', windSize);

        newWindow.document.body.innerHTML = '<div id="root"></div>';

        const cssLink = newWindow.document.createElement('link');
        cssLink.rel = 'stylesheet';

        // ✅ Priority logic:
        // 1. prop.cssFile
        // 2. dropdown selection
        // 3. fallback based on WebSrn
        let cssFile;

        if (props.cssFile) {
            cssFile = props.cssFile;
        } else if (selectedCSS) {
            cssFile = selectedCSS;
        } else if (WebSrn == 14 || WebSrn == 7 || WebSrn == 1) {
            cssFile = CSS_FILES.nayab;
        } else {
            cssFile = CSS_FILES.xaosoft;
        }

        cssLink.href = cssFile;

        newWindow.document.head.appendChild(cssLink);

        ReactDOM.render(
            <NewWindowContent />,
            newWindow.document.getElementById('root')
        );
    };

    return (
        <>
            {/* ✅ CSS Selector UI */}
            <div style={{ marginBottom: '10px' }}>
                <select onChange={(e) => setSelectedCSS(e.target.value)}>
                    <option value={CSS_FILES.nayab}>Nayab Card</option>
                    <option value={CSS_FILES.nayabHtml}>Nayab HTML</option>
                    <option value={CSS_FILES.wasilyCard}>Card Nayab</option>
                    <option value={CSS_FILES.xaosoft}>Xaosoft</option>
                </select>
            </div>

            <CustomBtn
                type="button"
                click={openNewWindow}
                data="Print Card  کارت چاپ کړئ"
            />
        </>
    );
}

export default NayabMultipleCards;